import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { EmrCheckboxGroupComponent } from "../../../../shared/emr-checkbox-group/emr-checkbox-group.component";
import { EmrCheckboxComponent } from "../../../../shared/emr-checkbox/emr-checkbox.component";
import { WnlManagerService } from '../wnl-manager.service';
import { FormOption } from 'src/app/shared/models/form-option.model';
import { GeneralAppearanceFormGroup } from 'src/app/calvin-emr-shared/models/assessments/general-appearance.model';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';

@Component({
  selector: 'app-general-appearance-form',
  templateUrl: './general-appearance-form.component.html',
  styleUrls: ['./general-appearance-form.component.scss', '../assessments-tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AssessmentRowComponent,
    EmrInputComponent,
    EmrCheckboxComponent,
    EmrCheckboxGroupComponent
  ],
})
export class GeneralAppearanceFormComponent {

  formGroup = input.required<GeneralAppearanceFormGroup>();
  patient = input.required<Patient>();
  wnlManager = new WnlManagerService();
  wnlManagerOB = new WnlManagerService();

  constructor() {
    this.reset();
  }

  reset() {
    this.wnlManager.setControls(
      [
        { control: 'loc', default: 'WNL', wnl: false },
      ]
    );

    this.wnlManagerOB.setControls(
      [
        { control: 'loc', default: 'WNL', wnl: false },
        { control: '', default: 'WNL', wnl: false }
      ]
    )
  }

  get locDefault() {
    return this.wnlManager.controlColl['loc'].default;
  }

  get areBreastsAbnormal(): boolean {
    return !!this.formGroup().controls.hasBreastAbnormalities.value;
  }

  locOptions = [
    new FormOption('Lethargic'),
    new FormOption('Somnolent'),
    new FormOption('WNL'),
  ];

  orientationOptions = [
    new FormOption('NOT TO person', 'person'),
    new FormOption('NOT TO place', 'place'),
    new FormOption('NOT TO time', 'time'),
    new FormOption('NOT TO situation', 'situation'),
  ];

}